import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

/**
 * Panel lateral derecho del módulo Odoo (calco de shadcn Sheet, side="right").
 * <od-sheet [abierto]="!!sel" titulo="…" subtitulo="…" (cerrar)="sel = null">
 *   <div od-sheet-acciones>…botones del encabezado…</div>
 *   …contenido…
 *   <ng-container od-sheet-pie>…botones fijos abajo…</ng-container>
 * </od-sheet>
 * Se cierra con Escape, con la X o tocando el fondo.
 */
@Component({
  selector: 'od-sheet',
  template: `
    <ng-container *ngIf="abierto">
      <div class="od-sheet-fondo" (click)="cerrar.emit()" aria-hidden="true"></div>
      <aside class="od-sheet" [class.od-gen-ancho]="ancho" role="dialog" aria-modal="true" [attr.aria-label]="titulo">
        <header class="od-sheet-h">
          <div class="od-sheet-tit">
            <h4>{{ titulo }}</h4>
            <p class="od-muted" *ngIf="subtitulo">{{ subtitulo }}</p>
          </div>
          <ng-content select="[od-sheet-acciones]"></ng-content>
          <button type="button" class="od-btn od-btn-sm od-btn-ghost od-sheet-x" (click)="cerrar.emit()" aria-label="Cerrar">
            <od-icon name="x" [size]="16"></od-icon>
          </button>
        </header>
        <div class="od-sheet-b"><ng-content></ng-content></div>
        <footer class="od-sheet-f"><ng-content select="[od-sheet-pie]"></ng-content></footer>
      </aside>
    </ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OdSheetComponent {
  @Input() abierto = false;
  @Input() titulo = '';
  @Input() subtitulo = '';
  /** Hoja ancha (detalles con tablas o varias columnas). */
  @Input() ancho = false;
  @Output() cerrar = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  alEscape(): void { if (this.abierto) this.cerrar.emit(); }
}
